"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgChannelVk = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgChannelVk = function SvgChannelVk(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.491 0H120v120H0V0h18.491z",
    fill: "url(#sc_vk__paint0_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58.993 84.004h4.909s1.482-.164 2.24-.98c.697-.749.675-2.155.675-2.155s-.096-6.587 2.96-7.557c3.014-.956 6.884 6.366 10.985 9.181 3.102 2.13 5.459 1.664 5.459 1.664l10.967-.153s5.737-.354 3.016-4.865c-.222-.368-1.584-3.337-8.154-9.435-6.878-6.383-5.956-5.35 2.328-16.39 5.045-6.725 7.061-10.83 6.431-12.587-.6-1.675-4.311-1.233-4.311-1.233l-12.348.077s-.916-.125-1.595.28c-.664.398-1.09 1.326-1.09 1.326s-1.955 5.203-4.56 9.628c-5.499 9.336-7.698 9.83-8.597 9.25-2.09-1.351-1.568-5.428-1.568-8.325 0-9.048 1.372-12.82-2.673-13.797-1.342-.324-2.33-.539-5.764-.574-4.406-.044-8.134.014-10.246 1.048-1.405.688-2.489 2.221-1.828 2.31.816.108 2.664.498 3.644 1.831 1.266 1.722 1.221 5.588 1.221 5.588s.727 10.652-1.698 11.974c-1.664.908-3.948-.945-8.85-9.415-2.511-4.34-4.408-9.136-4.408-9.136s-.365-.896-1.018-1.376c-.79-.581-1.896-.766-1.896-.766l-11.735.077s-1.761.05-2.408.815c-.576.682-.046 2.09-.046 2.09s9.186 21.494 19.588 32.325c9.54 9.932 20.37 9.28 20.37 9.28z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "sc_vk__paint0_linear",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#6B9DDF"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#4574B5"
  }))));
};

exports.SvgChannelVk = SvgChannelVk;